
      const siteUrl = import.meta.env.VITE_SITE_URL || 'https://polaristmobiledetailing.com';
      const schemaData = {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "Polarist Mobile Detailing",
        "description": "Professional mobile auto detailing service in Greater Toronto Area",
        "url": siteUrl,
        "telephone": "647-558-2086",
        "address": {
          "@type": "PostalAddress",
          "addressRegion": "ON",
          "addressCountry": "CA",
          "addressLocality": "Greater Toronto Area"
        },
        "openingHours": [
          "Mo-Sa 08:00-18:00",
          "Su 10:00-16:00"
        ],
        "priceRange": "$149-$299",
        "serviceArea": {
          "@type": "GeoCircle",
          "geoMidpoint": {
            "@type": "GeoCoordinates",
            "latitude": 43.6532,
            "longitude": -79.3832
          },
          "geoRadius": "50000"
        }
      };
      
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify(schemaData);
      document.head.appendChild(script);
    